import React from 'react';
import { Stethoscope, Pill, Siren, Coffee, Hotel, Bath } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const CATEGORIES = [
  { key: 'clinic', label: 'Clinic', icon: Stethoscope },
  { key: 'pharmacy', label: 'Pharmacy', icon: Pill },
  { key: 'emergency', label: 'Emergency', icon: Siren },
  { key: 'cafe', label: 'Cafe', icon: Coffee },
  { key: 'hotel', label: 'Hotel', icon: Hotel },
  { key: 'washroom', label: 'Washroom', icon: Bath },
];

export default function NeedNowGrid() {
  const navigate = useNavigate();
  return (
    <div data-testid="need-now-grid">
      <div className="flex items-center justify-between px-1 mb-3">
        <h3 className="text-base font-semibold">Need now</h3>
        <button type="button" onClick={() => navigate('/map')} className="text-xs font-medium text-[#15291C] puvio-focus rounded-full px-2 py-1" data-testid="need-now-view-map">View on map</button>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {CATEGORIES.map(({ key, label, icon: Icon }) => (
          <button
            type="button"
            key={key}
            onClick={() => navigate(`/need/${key}`)}
            className="rounded-[22px] bg-[#0F1A13]/05 border border-black/5 shadow-[0_8px_24px_rgba(0,0,0,0.04)] p-3 flex flex-col items-center gap-2 active:scale-[0.98] transition-transform hover:bg-[#C4FF3D]/30 puvio-focus"
            data-testid={`need-now-tile-${key}`}
          >
            <span className="w-10 h-10 rounded-2xl bg-white flex items-center justify-center shadow-sm">
              <Icon className="w-5 h-5 text-[#15291C]" />
            </span>
            <span className="text-xs font-medium">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
